module.exports = __webpack_public_path__ + "img/arrow_down-short.098fc725.svg";